var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.article && _vm.isProduct)?_c('div',[_c('ProductArticle',{attrs:{"article":_vm.article}})],1):_c('div',[_c('PageHeader'),_vm._v(" "),_c('DefaultArticle',{attrs:{"article":_vm.article}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }